import { STORE_ITEM_CLASS_NAME } from 'modules/stores/store/constants/store-item-class-name'
import { twJoin, twMerge } from 'tailwind-merge'

const BASE_CLASS = 'animate-pulse bg-skeleton-primary text-transparent'

const ContentSkeleton = () => (
  <div className={'flex flex-col gap-5'}>
    <div
      className={twMerge(
        STORE_ITEM_CLASS_NAME,
        'flex flex-col items-center gap-5 sm:items-start lg:flex-row',
      )}
    >
      <div className={twJoin(BASE_CLASS, 'h-32 w-32 shrink-0 rounded-full')}>.</div>
      <div className={'flex w-full flex-col gap-3'}>
        <div className={twJoin(BASE_CLASS, 'h-6 w-full rounded-md')}>.</div>
        <div className={twJoin(BASE_CLASS, 'h-6 w-full rounded-md')}>.</div>
        <div className={twJoin(BASE_CLASS, 'h-6 w-full rounded-md')}>.</div>
      </div>
    </div>
    <div className={twMerge(STORE_ITEM_CLASS_NAME, 'flex flex-col gap-3')}>
      <div className={twJoin(BASE_CLASS, 'h-6 w-full rounded-md')}>.</div>
      <div className={twJoin(BASE_CLASS, 'h-6 w-full rounded-md')}>.</div>
      <div className={twJoin(BASE_CLASS, 'h-6 w-full rounded-md')}>.</div>
    </div>
    <div className={twMerge(STORE_ITEM_CLASS_NAME, 'flex flex-col gap-3')}>
      <div className={twJoin(BASE_CLASS, 'h-6 w-full rounded-md')}>.</div>
      <div className={twJoin(BASE_CLASS, 'h-6 w-full rounded-md')}>.</div>
      <div className={twJoin(BASE_CLASS, 'h-6 w-full rounded-md')}>.</div>
    </div>
  </div>
)

export default ContentSkeleton
